((root, factory) => {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.MoveCalmlyCustomerAddressState = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, () => {
  function optionForDefault(select, value) {
    return [...select.options].find((option) => option.value === value || option.textContent === value);
  }

  function sync(country, province, provinceContainer, createOption) {
    const selected = country.options[country.selectedIndex];
    let choices = [];
    try { choices = JSON.parse(selected?.dataset.provinces || '[]'); } catch { choices = []; }
    province.replaceChildren();
    choices.forEach(([label, value]) => {
      const option = createOption();
      option.value = value;
      option.textContent = label;
      province.append(option);
    });
    const selectedProvince = optionForDefault(province, province.dataset.default || '');
    if (selectedProvince) province.value = selectedProvince.value;
    const hasProvinces = choices.length > 0;
    province.disabled = !hasProvinces;
    provinceContainer.hidden = !hasProvinces;
    return choices;
  }

  function init(scope, createOption = () => document.createElement('option')) {
    let initialized = 0;
    scope.querySelectorAll('[data-address-country]').forEach((country) => {
      if (country.dataset.mcInitialized === 'true') return;
      const form = country.closest('form');
      const province = form?.querySelector('[data-address-province]');
      const provinceContainer = form?.querySelector('[data-address-province-container]');
      if (!province || !provinceContainer) return;
      const countryOption = optionForDefault(country, country.dataset.default || '');
      if (countryOption) country.value = countryOption.value;
      const syncProvinces = () => sync(country, province, provinceContainer, createOption);
      country.dataset.mcInitialized = 'true';
      country.addEventListener('change', syncProvinces);
      syncProvinces();
      initialized += 1;
    });
    return initialized;
  }

  return Object.freeze({ init, optionForDefault, sync });
});
